define('views/modals/select-deal/index',[
    'jquery',
    'underscore',
    'mediator',

    'views/base/modal',
    'views/modals/select-deal/content',
    'lib/utils'
], function(
    $, _, mediator,
    ModalView,
    SelectDealModalContentView
) {
    'use strict';

    var SeletDealModalView = ModalView.extend({
        listen: {
        },
        initialize: function() {
            ModalView.prototype.initialize.apply(this, arguments);
        },
        render: function() {
            ModalView.prototype.render.apply(this, arguments);

            this.subview('content', new SelectDealModalContentView({ model: this.model.content }));
        }
    });

    return SeletDealModalView;
});

